// extracted by mini-css-extract-plugin
export default {"info":"urvEw","giftIcon":"ZxWJp","messageWrapper":"at_N9","name":"TVOL6","message":"T8QiC","button":"Q9SE7"};